/* GLINTURA theme JS — assets/glintura.js */
(function(){
  'use strict';
  var FREE_SHIP_THRESHOLD = window.GLINTURA_FREE_SHIP || 99900; // in paise (₹999)

  function $(s,ctx){return (ctx||document).querySelector(s);}
  function money(cents){return '₹'+(cents/100).toLocaleString('en-IN',{maximumFractionDigits:0});}

  /* ---- sticky header shrink ---- */
  var header = $('.gl-header');
  if(header){window.addEventListener('scroll',function(){header.classList.toggle('shrink',window.scrollY>30);});}

  /* ---- announcement rotation ---- */
  var track = $('[data-announce]');
  if(track){
    var items = JSON.parse(track.getAttribute('data-announce')||'[]');
    if(items.length>1){var i=0;setInterval(function(){i=(i+1)%items.length;track.innerHTML='<span>'+items[i]+'</span>';},3200);}
  }

  /* ---- drawers / sheets ---- */
  function open(el){if(el){el.classList.add('show');var s=$('.scrim');if(s)s.classList.add('show');document.body.style.overflow='hidden';}}
  function close(el){if(el)el.classList.remove('show');document.body.style.overflow='';}
  function closeAll(){document.querySelectorAll('.drawer,.msheet').forEach(function(d){d.classList.remove('show');});var s=$('.scrim');if(s)s.classList.remove('show');document.body.style.overflow='';}

  document.addEventListener('click',function(e){
    var t=e.target.closest('[data-action]');
    if(!t)return;
    var a=t.getAttribute('data-action');
    if(a==='open-cart'){e.preventDefault();refreshCart();open($('#cart-drawer'));}
    if(a==='close-cart'){close($('#cart-drawer'));var s=$('.scrim');if(s)s.classList.remove('show');document.body.style.overflow='';}
    if(a==='open-menu'){open($('#mobile-menu'));}
    if(a==='close-menu'){close($('#mobile-menu'));var s=$('.scrim');if(s)s.classList.remove('show');document.body.style.overflow='';}
    if(a==='close-all'){closeAll();}
  });
  var scrim=$('.scrim');if(scrim)scrim.addEventListener('click',closeAll);
  document.addEventListener('keydown',function(e){if(e.key==='Escape')closeAll();});

  /* ---- AJAX cart ---- */
  function setCount(n){document.querySelectorAll('[data-cart-count]').forEach(function(el){el.textContent=n;el.style.display=n>0?'grid':'none';});}

  function renderShipBar(total){
    var bar=$('[data-ship-msg]'),fill=$('[data-ship-fill]');
    if(!bar)return;
    if(total>=FREE_SHIP_THRESHOLD){bar.innerHTML='🎉 You\u2019ve unlocked <b>free shipping!</b>';if(fill)fill.style.width='100%';}
    else{var left=FREE_SHIP_THRESHOLD-total;bar.innerHTML='You\u2019re <b>'+money(left)+'</b> away from <b>free shipping</b> \u2726';if(fill)fill.style.width=Math.min(100,total/FREE_SHIP_THRESHOLD*100)+'%';}
  }

  function refreshCart(){
    fetch('/cart.js').then(function(r){return r.json();}).then(function(cart){
      setCount(cart.item_count);
      renderShipBar(cart.total_price);
      var body=$('[data-cart-items]');
      if(body){
        if(!cart.items.length){body.innerHTML='<div class="cart-empty">Your cart is empty.<br><br><a class="btn btn-ghost" href="/collections/all">Shop earrings</a></div>';}
        else{
          body.innerHTML=cart.items.map(function(it){
            return '<div class="citem">'+
              '<img src="'+(it.image?it.image.replace(/(\.[a-z]+)(\?|$)/,'_120x$1$2'):'')+'" alt="">'+
              '<div style="flex:1"><h4>'+it.product_title+'</h4><small>'+(it.variant_title||'')+'</small>'+
              '<div class="ci-bot"><div class="qty">'+
              '<button data-qty="'+it.key+'" data-delta="-1">\u2212</button><span>'+it.quantity+'</span>'+
              '<button data-qty="'+it.key+'" data-delta="1">+</button></div>'+
              '<span class="ci-price">'+money(it.final_line_price)+'</span></div></div></div>';
          }).join('');
        }
      }
      var sub=$('[data-cart-subtotal]');if(sub)sub.textContent=money(cart.total_price);
    });
  }

  // add to cart (forms or buttons with data-add)
  document.addEventListener('submit',function(e){
    var form=e.target.closest('form[action*="/cart/add"]');
    if(!form)return;
    e.preventDefault();
    fetch('/cart/add.js',{method:'POST',body:new FormData(form),headers:{'Accept':'application/json'}})
      .then(function(r){return r.json();}).then(function(){refreshCart();open($('#cart-drawer'));});
  });

  // qty change inside drawer
  document.addEventListener('click',function(e){
    var b=e.target.closest('[data-qty]');if(!b)return;
    var key=b.getAttribute('data-qty'),delta=parseInt(b.getAttribute('data-delta'),10);
    var span=b.parentElement.querySelector('span');var q=Math.max(0,parseInt(span.textContent,10)+delta);
    fetch('/cart/change.js',{method:'POST',headers:{'Content-Type':'application/json'},body:JSON.stringify({id:key,quantity:q})})
      .then(function(r){return r.json();}).then(function(){refreshCart();});
  });

  // init counts on load
  refreshCart();
})();

/* accordions (FAQ / product) + pincode checker */
(function(){
  document.addEventListener('click',function(e){
    var h=e.target.closest('.acc-h');
    if(h){h.parentElement.classList.toggle('open');}
  });
  window.glPincode=function(){
    var i=document.getElementById('pincode'); if(!i)return;
    var r=document.getElementById('pinres'); var v=i.value.trim();
    if(v.length>=6){r.innerHTML='\u2705 Delivers to <b>'+v+'</b> in 3\u20135 days \u00b7 COD available';}
    else{r.innerHTML='Please enter a valid 6-digit pincode';}
    r.classList.add('show');
  };
})();
